import { Utils } from '@/plugin/gis-viewer/Utils';
import { IGeometrySearchParameter, IResult } from '@/types/map';
import { loadModules } from 'esri-loader';
import Polygon from 'esri/geometry/Polygon';
import { DrawOverlays } from '../../DrawOverlays/arcgis/DrawOverlays';

export class GeometrySearch {
    private static intances: Map<string, any>;
    private view!: any;
    private searchOverlays: any;
    private _mapClick: any;
    private initialize: boolean = false;

    //替换查找结果的图标
    private _replaceTargetIcon: any;
    private _replacedTargets: Map<any, any>; //被替换图标的覆盖物和原图标

    private constructor(view: any) {
        this.view = view;
        this._replacedTargets = new Map<any, any>();
    }

    public static getInstance(view: __esri.MapView | __esri.SceneView) {
        let id = view.container.id;
        if (!GeometrySearch.intances) {
            GeometrySearch.intances = new Map();
        }
        let intance = GeometrySearch.intances.get(id);
        if (!intance) {
            intance = new GeometrySearch(view);
            GeometrySearch.intances.set(id, intance);
        }
        return intance;
    }
    public static destroy() {
        (GeometrySearch.intances as any) = null;
    }
    private _clear() {
        if (this._mapClick) {
            this._mapClick.remove();
            this._mapClick = undefined;
        }
    }

    public async clearGeometrySearch() {
        // console.log("[debug][gisviewer-vue] clearGeometrySearch");
        this._clear();
        if (this.searchOverlays) {
            this.searchOverlays.removeAll();
        }
        const drawoverlay = DrawOverlays.getInstance(this.view);
        drawoverlay.clear();
        drawoverlay.stopDrawOverlays();
        let layers = this.view.map.allLayers;
        if (this.initialize) {
            this.initialize = false;
            layers.forEach((layer: any) => {
                if (layer.type == 'graphics') {
                    if (layer.defaultVisible !== undefined) {
                        layer.visible = layer.defaultVisible;
                    }
                    let overlays = layer.graphics;
                    overlays.forEach((overlay: any) => {
                        overlay.visible = true;
                        if (layer.defaultVisible === false) {
                            if (overlay.tooltip) {
                                overlay.tooltip.hide();
                            }
                        }
                        if (layer.defaultVisible) {
                            if (overlay.tooltip) {
                                overlay.tooltip.show();
                            }
                        }
                    });
                    delete layer.defaultVisible;
                }
            });
        }
        //删除几何查找图层
        this.view.map.remove(this.searchOverlays);
        this.searchOverlays = undefined;
        //还原替换的搜索图标
        this._replacedTargets.forEach((sym_old: any, overlay: any) => {
            overlay.symbol = sym_old;
        });
        this._replacedTargets.clear();
    }
    public async startGeometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
        // console.log("[debug][gisviewer-vue] startGeometrySearch", params);
        this._clear();
        this.initialize = true;
        let center = params.center; //搜索中心
        let drawType = params.drawType || 'point';
        console.log(drawType, 2221);

        let that = this;
        if (!center) {
            return new Promise((resolve, reject) => {
                if (drawType == 'point') {
                    that._mapClick = that.view.on('click', async (event: any) => {
                        let clickPoint = event.mapPoint;
                        params.center = [clickPoint.longitude, clickPoint.latitude];
                        that.geometrySearch(params).then((res: any) => {
                            resolve(res);
                        });
                    });
                } else {
                    const drawoverlay = DrawOverlays.getInstance(that.view);
                    drawoverlay.startDrawOverlays({
                        drawType: drawType,
                        repeat: false,
                        update: false,
                        symbol: params.drawSymbol,
                        callback: (res: any) => {
                            params.geometry = res.geometry;
                            params.graphic = res.data;
                            that.geometrySearch(params).then((res: any) => {
                                resolve(res);
                            });
                        },
                    });
                }
            });
        } else {
            return this.geometrySearch(params);
        }
    }
    private async createOverlayLayer() {
        type MapModules = [typeof import('esri/layers/GraphicsLayer')];
        const [GraphicsLayer] = await (loadModules(['esri/layers/GraphicsLayer']) as Promise<MapModules>);
        this.searchOverlays = new GraphicsLayer();
        // this.view.map.add(this.searchOverlays, 0);//放在底层
        let index = (this.view as any).mapConfig.operationallayers?.length || 0;
        this.view.map.add(this.searchOverlays, index); //放在operationallayers的上层
    }
    private async showClusterPoint(layer: any, datas: any) {
        type MapModules = [typeof import('esri/Graphic'), typeof import('esri/geometry/Point')];
        const [Graphic, Point] = await (loadModules(['esri/Graphic', 'esri/geometry/Point']) as Promise<MapModules>);

        layer.defaultVisible = layer.visible;
        layer.visible = false;

        let defaultSymbol = layer.clusterRenderer.defaultSymbol;
        let texts: any[] = [];
        let graphics = datas.map((item: any) => {
            let symbol = item.symbol ? item.symbol : defaultSymbol;
            let geometry = new Point({
                longitude: item.x,
                latitude: item.y,
                spatialReference: { wkid: 4326 },
            });
            let pointGra = new Graphic({
                geometry: geometry,
                symbol: symbol,
                attributes: item,
            });
            if (layer.customText && layer.customText.content) {
                let customText = layer.customText;
                let textsymbol = {
                    type: 'text', // autocasts as new TextSymbol()
                    color: customText.color || 'red',
                    text: customText.content || '',
                    backgroundColor: customText.backgroundColor || 'black',
                    borderLineColor: customText.lineColor || 'white',
                    borderLineSize: customText.lineWidth || 1,
                    font: {
                        // autocasts as new Font()
                        size: customText.fontSize || 10,
                        weight: customText.weight || 'bold',
                    },
                    yoffset: 0,
                };

                var symOffset = symbol.yoffset ? symbol.yoffset : 0;
                textsymbol.yoffset = symbol.height / 2 + symOffset;
                textsymbol.text = Utils.getContent(item, customText.content);
                var graphicText = new Graphic({
                    geometry: geometry,
                    symbol: textsymbol,
                });
                texts.push(graphicText);
            }

            return pointGra;
        });
        this.searchOverlays.addMany(graphics);
        this.searchOverlays.addMany(texts);
    }
    private async geometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
        let repeat = params.repeat !== false;
        type MapModules = [
            typeof import('esri/geometry/Point'),
            typeof import('esri/geometry/Circle'),
            typeof import('esri/geometry/Geometry'),
            typeof import('esri/symbols/SimpleFillSymbol'),
            typeof import('esri/symbols/SimpleMarkerSymbol'),
            typeof import('esri/Graphic'),
            typeof import('esri/geometry/geometryEngine'),
            typeof import('esri/geometry/support/webMercatorUtils'),
            typeof import('esri/geometry/support/geodesicUtils'),
            typeof import('esri/geometry/Polygon')
        ];
        const [Point, Circle, Geometry, SimpleFillSymbol, SimpleMarkerSymbol, Graphic, geometryEngine, WebMercatorUtils, geodesicUtils, Polygon] = await (loadModules([
            'esri/geometry/Point',
            'esri/geometry/Circle',
            'esri/geometry/Geometry',
            'esri/symbols/SimpleFillSymbol',
            'esri/symbols/SimpleMarkerSymbol',
            'esri/Graphic',
            'esri/geometry/geometryEngine',
            'esri/geometry/support/webMercatorUtils',
            'esri/geometry/support/geodesicUtils',
            'esri/geometry/Polygon',
        ]) as Promise<MapModules>);

        if (!repeat) {
            this._clear();
        }

        if (!this.searchOverlays) {
            await this.createOverlayLayer();
        } else {
            this.searchOverlays.removeAll();
        }
        let radius = params.radius || 1000; //搜索半径,单位米
        let center = (params.center as number[]) || undefined; //搜索中心
        let drawType = params.drawType || 'point';
        let searchTypes = params.types || ['*']; //搜索点位类型
        const allMap = params.allMap || false; // 是否查找远程的服务图层
        let showResult = params.showResult !== false;
        let showGeometry = params.showGeometry !== false;
        let centerResult = params.centerResult !== false;
        let zoom = params.zoom || 0;
        let geometryList = params.geometryList || ['*']; //查找点位的图层数组
        let clickHandle = params.clickHandle;
        this._replaceTargetIcon = params.targetSymbol; //是否替换结果图标

        let searchGeometry = params.geometry || undefined;
        let centerGeo: any;
        if (center) {
            centerGeo = new Point({
                longitude: center[0],
                latitude: center[1],
                spatialReference: { wkid: 4326 },
            });
            if (drawType == 'point') {
                searchGeometry = new Circle({
                    center: centerGeo,
                    radius: radius,
                    radiusUnit: 'meters',
                    geodesic: true,
                });
            } else if (drawType == 'polygon') {
                searchGeometry = new Polygon({
                    spatialReference: { wkid: 4326 },
                    rings: geometryList,
                });
            }
            let circleGraphic = new Graphic({
                geometry: searchGeometry,
                symbol: new SimpleFillSymbol({
                    style: 'solid',
                    color: params.drawSymbol?.color || [23, 145, 252, 0.4],
                    outline: {
                        style: params.drawSymbol?.outline?.style || 'dash',
                        color: params.drawSymbol?.outline?.color || [255, 0, 0, 0.8],
                        width: params.drawSymbol?.outline?.width || 2,
                    },
                }),
                attributes: {
                    type: 'geometrysearch',
                    id: 'geometrysearch-id',
                },
            });
            let centerGraphic = new Graphic({
                geometry: centerGeo,
                symbol: new SimpleMarkerSymbol({
                    style: 'circle',
                    color: [255, 0, 0, 0.8],
                    outline: {
                        color: [255, 0, 0, 0.8],
                        width: 2,
                    },
                }),
                attributes: {
                    type: 'geometrysearch',
                },
            });
            if (showGeometry) {
                this.searchOverlays.add(circleGraphic);
                //this.searchOverlays.add(centerGraphic);
            }
        }
        console.log(centerResult, searchGeometry, '进去了吗');

        if (centerResult) {
            if (zoom && zoom > 0) {
                await this.view.goTo({ target: searchGeometry, zoom: zoom });
            } else {
                await this.view.goTo({ target: searchGeometry });
            }
        }
        //如果是线,则搜索线的缓冲区
        if (searchGeometry.type == 'polyline') {
            searchGeometry = this.view.spatialReference.isWebMercator ? geometryEngine.buffer(searchGeometry, radius, 'meters') : geometryEngine.geodesicBuffer(searchGeometry, radius, 'meters');
        }
        // let _this = this;
        // return new Promise((resolve, reject) => {
        let overlays = this.view.map.allLayers;
        let searchRses = new Array();
        let graphicsRes = new Array();
        let tooltips = new Array();

        // if (centerGeo) {
        //   centerGeo = this.view.spatialReference.isWebMercator
        //     ? WebMercatorUtils.geographicToWebMercator(centerGeo)
        //     : centerGeo;
        // }

        for (let i = 0; i < overlays.length; ++i) {
            const layer = overlays.items[i];
            // await overlays.forEach(async (layer: any) => {
            if (layer.label !== 'drawOverlays') {
                if (layer.type == 'graphics') {
                    if (layer.data && (searchTypes.indexOf(layer.label) >= 0 || searchTypes.indexOf('*') > -1)) {
                        //cluster点位
                        let datas = layer.data;
                        datas.forEach((item: any) => {
                            let overlayType = item.type;
                            if (searchTypes.indexOf(overlayType) >= 0 || searchTypes.indexOf('*') > -1) {
                                let pt = new Point({
                                    longitude: item.x,
                                    latitude: item.y,
                                    spatialReference: { wkid: 4326 },
                                });
                                if (searchGeometry.contains(pt)) {
                                    let res: any;
                                    if (centerGeo) {
                                        //求距离
                                        res = geodesicUtils.geodesicDistance(centerGeo, pt, 'meters');
                                    }
                                    searchRses.push({
                                        isCluster: true,
                                        distance: res ? res.distance : 0,
                                        ...item,
                                    });
                                }
                                if (showResult) {
                                    this.showClusterPoint(layer, searchRses);
                                }
                            }
                        }, this);
                    } else {
                        layer.graphics.forEach((overlay: any) => {
                            let point = overlay.geometry;
                            let overlayType = overlay.type || overlay.attributes ? overlay.attributes.type : '';
                            if ((searchTypes.indexOf(overlayType) >= 0 || searchTypes.indexOf('*') > -1) && overlayType !== 'geometrysearch') {
                                if (searchGeometry.contains(point)) {
                                    overlay.visible = true;
                                    if (showResult) {
                                        if (overlay.tooltip) {
                                            overlay.tooltip.show();
                                        }
                                    }
                                    //替换结果点位图标
                                    if (this._replaceTargetIcon && overlay.symbol.type === 'picture-marker') {
                                        let rti = this._replaceTargetIcon;
                                        let sym_old = overlay.symbol;
                                        let sym_new = {
                                            type: 'picture-marker', // autocasts as new PictureMarkerSymbol()
                                            url: rti.url,
                                            width: rti.width,
                                            height: rti.height,
                                        };
                                        overlay.symbol = sym_new;
                                        this._replacedTargets.set(overlay, sym_old);
                                    }

                                    let res: any;
                                    if (centerGeo) {
                                        //求距离
                                        res = geodesicUtils.geodesicDistance(centerGeo, point, 'meters');
                                    }
                                    searchRses.push({
                                        distance: res ? res.distance : 0,
                                        id: overlay.id,
                                        type: overlayType,
                                        x: point.x,
                                        y: point.y,
                                        symbol: overlay.symbol,
                                        attributes: overlay.attributes,
                                        geometry: overlay.geometry,
                                        ...overlay.attributes,
                                    });
                                } else {
                                    if (showResult) {
                                        overlay.visible = false;
                                        if (overlay.tooltip) {
                                            overlay.tooltip.hide();
                                        }
                                    }
                                }
                            }
                        });

                        if (showResult && (searchTypes.indexOf(layer.label) >= 0 || searchTypes.indexOf('*') > -1)) {
                            if (layer.defaultVisible === undefined) {
                                layer.defaultVisible = layer.visible;
                                layer.visible = true;
                            }
                        }
                    }
                } else if (layer.type == 'feature' && layer.source && layer.source.items) {
                    layer.source.items.forEach((graphic: any, index: number) => {
                        let point = graphic.geometry;
                        let overlayType = graphic.attributes.type;
                        if ((searchTypes.indexOf(overlayType) >= 0 || searchTypes.indexOf('*') > -1) && overlayType !== 'geometrysearch') {
                            if (searchGeometry.contains(point)) {
                                searchRses.push({
                                    id: graphic.attributes.OBJECTID || index,
                                    type: overlayType,
                                    x: point.x,
                                    y: point.y,
                                    symbol: graphic.symbol,
                                    attributes: graphic.attribute,
                                    geometry: graphic.geometry,
                                    ...overlayType.attributes,
                                });
                            }
                        }
                    });
                    layer.refresh();
                } else if (layer.type == 'tile') {
                    layer.refresh();
                }
                // 对远程的feature图层做查找
                if (allMap) {
                    if (searchTypes.indexOf(layer.label) >= 0 || searchTypes.indexOf('*') > -1) {
                        // 找到所有要素
                        const results = await layer.queryFeatures();
                        // console.log("aaa");
                        // qres.then(function (results: any) {
                        // console.log(results); // prints all the client-side features to the console
                        results.features.forEach((graphic: any, index: any) => {
                            let point = graphic.geometry;
                            let overlayType = graphic.attributes.type || layer.label;
                            if (searchGeometry.contains(point)) {
                                searchRses.push({
                                    id: graphic.attributes.OBJECTID || index,
                                    type: overlayType,
                                    x: point.longitude,
                                    y: point.latitude,
                                    symbol: graphic.symbol,
                                    attributes: graphic.attribute,
                                    geometry: graphic.geometry,
                                    ...graphic.attributes,
                                });
                            }
                        });
                        // });
                    }
                }
            }
            // });
        }

        // let searchResult = searchRses.map((result: any) => {
        //   return {
        //     positon: result.geometry,
        //     attr: result.attributes
        //   };
        // });
        let polygoncenter = searchGeometry.centroid || searchGeometry.center;
        if (polygoncenter) {
            polygoncenter = [polygoncenter.longitude, polygoncenter.latitude];
        }
        let geo = params.geometry;
        if (params.geometry && params.geometry.spatialReference.isWebMercator) {
            geo = WebMercatorUtils.webMercatorToGeographic(params.geometry);
        }
        let searchGeometryJson: any = {
            geometry: geo,
            fields: {},
            id: 'drawline1',
            symbol: { color: 'red', width: 2 },
        };
        let searchResults = {
            center: center || polygoncenter,
            radius: center ? radius : 0,
            geometry: geo,
            searchResults: searchRses,
            searchGeometryJson: JSON.stringify({
                type: 'geometrysearch',
                overlays: [searchGeometryJson],
            }),
            drawGeometryJson: JSON.stringify(params.graphic),
            searchPointJson: JSON.stringify({
                type: 'geometrysearch',
                overlays: center ? '' : Utils.getGraphicObject(searchRses),
            }),
        };
        if (clickHandle) {
            clickHandle(searchResults);
        }
        // console.log("bbb");
        // resolve({
        //   status: 0,
        //   message: "success",
        //   result: searchResults,
        // });
        return {
            status: 0,
            message: 'success',
            result: searchResults,
        };

        // });
    }
}
